import { render } from "./user-group-membership.vue?vue&type=template&id=3ee4be68&scoped=true"
import script from "./user-group-membership.vue?vue&type=script&lang=js"
export * from "./user-group-membership.vue?vue&type=script&lang=js"

import "./user-group-membership.vue?vue&type=style&index=0&id=3ee4be68&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee4be68"]])

export default __exports__